/*
  Brickcessories custom: "Arrives by" delivery estimate on product pages.
  Markup and settings: snippets/product-shipping-info.liquid.
  Rules (Greg, 11/4/2026):
    - Cutoff hour is Eastern time; ship days are Mon-Fri minus closed dates.
    - Start day = today if before cutoff on a ship day, else the next ship day.
    - Ship day = start day + max(handling - 1, 0) ship days.
    - "Arrives <early> to <late>": early = ship day + typical transit, late = ship day + 9-in-10 transit (calendar days for the state),
      + peak extra days if the ship day is in peak season; Sunday or a closed
      date rolls to the next day.
  State comes from a ZIP the shopper entered (saved in this browser), then a
  logged-in customer's address, else the national figure.
  Countdown wording is Amazon-style ("Order within 1 hr 16 min."), no ship day (Greg 11/4).
  QA: add ?de_now=2026-11-06T13:05 to the URL to pretend it is that Eastern time.
*/
(function () {
  'use strict';

  var TZ = 'America/New_York';
  var ZIP_KEY = 'bcs_delivery_zip';
  var COUNTDOWN_HOURS = 12;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // First 3 ZIP digits -> state. Only states we estimate for; anything else
  // (AK, HI, PR, territories, military) gets a ship date without an arrival date.
  var ZIP3 = [
    [5, 5, 'NY'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'], [39, 49, 'ME'],
    [50, 54, 'VT'], [55, 55, 'MA'], [56, 59, 'VT'], [60, 69, 'CT'], [70, 89, 'NJ'],
    [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'], [200, 200, 'DC'],
    [201, 201, 'VA'], [202, 205, 'DC'], [206, 219, 'MD'], [220, 246, 'VA'],
    [247, 268, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'],
    [320, 339, 'FL'], [341, 349, 'FL'], [350, 369, 'AL'], [370, 385, 'TN'],
    [386, 397, 'MS'], [398, 399, 'GA'], [400, 427, 'KY'], [430, 459, 'OH'],
    [460, 479, 'IN'], [480, 499, 'MI'], [500, 528, 'IA'], [530, 549, 'WI'],
    [550, 567, 'MN'], [569, 569, 'DC'], [570, 577, 'SD'], [580, 588, 'ND'],
    [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'], [660, 679, 'KS'],
    [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'], [730, 732, 'OK'],
    [733, 733, 'TX'], [734, 749, 'OK'], [750, 799, 'TX'], [800, 816, 'CO'],
    [820, 831, 'WY'], [832, 838, 'ID'], [840, 847, 'UT'], [850, 865, 'AZ'],
    [870, 884, 'NM'], [885, 885, 'TX'], [889, 898, 'NV'], [900, 961, 'CA'],
    [970, 979, 'OR'], [980, 994, 'WA']
  ];

  function zipToState(zip) {
    var n = parseInt(String(zip).slice(0, 3), 10);
    if (isNaN(n)) return null;
    for (var i = 0; i < ZIP3.length; i++) {
      if (n >= ZIP3[i][0] && n <= ZIP3[i][1]) return ZIP3[i][2];
    }
    return null;
  }

  function storageGet() {
    try { return window.localStorage.getItem(ZIP_KEY) || ''; } catch (e) { return ''; }
  }
  function storageSet(v) {
    try { window.localStorage.setItem(ZIP_KEY, v); } catch (e) { /* private mode etc. */ }
  }

  // "Now" as an Eastern wall-clock time: {date (UTC midnight of the Eastern day), minutes}
  function easternNow() {
    var m = /[?&]de_now=(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(decodeURIComponent(window.location.search));
    if (m) {
      return {
        date: new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])),
        minutes: +m[4] * 60 + +m[5]
      };
    }
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      minutes: +parts.hour * 60 + +parts.minute
    };
  }

  function iso(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }
  function sameDay(a, b) { return iso(a) === iso(b); }
  function fmtShort(d) { return DAYS_SHORT[d.getUTCDay()] + ', ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate(); }

  function compute(el, state) {
    var handling = parseInt(el.getAttribute('data-handling'), 10);
    if (isNaN(handling)) handling = 1;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 12;
    var closed = (el.getAttribute('data-closed') || '').split(',').filter(Boolean);
    var peakStart = el.getAttribute('data-peak-start') || '';
    var peakEnd = el.getAttribute('data-peak-end') || '';
    var peakExtra = parseInt(el.getAttribute('data-peak-extra'), 10) || 0;
    var transit = {};
    try { transit = JSON.parse(el.querySelector('[data-transit]').textContent) || {}; } catch (e) { transit = {}; }

    function isShipDay(d) {
      var w = d.getUTCDay();
      return w >= 1 && w <= 5 && closed.indexOf(iso(d)) === -1;
    }
    function nextShipDay(d) {
      var x = addDays(d, 1);
      while (!isShipDay(x)) x = addDays(x, 1);
      return x;
    }

    var now = easternNow();
    var today = now.date;
    var beforeCutoff = isShipDay(today) && now.minutes < cutoff * 60;
    var start = beforeCutoff ? today : nextShipDay(today);
    var ship = start;
    for (var i = 1; i < handling; i++) ship = nextShipDay(ship);

    // The shown date holds until the cutoff on the start day. Count down only
    // when that is within COUNTDOWN_HOURS (Greg 11/4: 12 hours, for urgency).
    var minsToCutoff = Math.round((start - today) / 60000) + cutoff * 60 - now.minutes;

    var result = {
      today: today,
      ship: ship,
      minutesLeft: minsToCutoff <= COUNTDOWN_HOURS * 60 ? minsToCutoff : null,
      arrive: null,
      arriveEarly: null
    };

    var t = state ? transit[state] : transit.US;
    if (t && t.length > 1) {
      var s = iso(ship);
      var extra = (peakExtra && peakStart && peakEnd && s >= peakStart && s <= peakEnd) ? peakExtra : 0;
      var landOn = function (days) {
        var a = addDays(ship, Math.max(days, 1) + extra);
        while (a.getUTCDay() === 0 || closed.indexOf(iso(a)) !== -1) a = addDays(a, 1);
        return a;
      };
      result.arriveEarly = landOn(t[0]); // typical: half arrive by then
      result.arrive = landOn(t[1]);      // 9 in 10 arrive by then
    }
    return result;
  }

  function shipWords(r) {
    if (sameDay(r.ship, r.today)) return 'today';
    if (sameDay(r.ship, addDays(r.today, 1))) return 'tomorrow';
    var diff = Math.round((r.ship - r.today) / 86400000);
    return diff < 7 ? DAYS[r.ship.getUTCDay()] : fmtShort(r.ship);
  }

  function countdown(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (h && m) return h + ' hr ' + m + ' min';
    if (h) return h + ' hr';
    return m + ' min';
  }

  function render(el) {
    var main = el.querySelector('.delivery-estimate__main');
    var sub = el.querySelector('.delivery-estimate__sub');
    var zipWrap = el.querySelector('.delivery-estimate__zip');
    var toggle = el.querySelector('.delivery-estimate__zip-toggle');
    var form = el.querySelector('.delivery-estimate__zip-form');
    var country = el.getAttribute('data-country');

    var zip = storageGet();
    var state = zip ? zipToState(zip) : null;
    var known = !!zip;
    if (!zip && el.getAttribute('data-customer-state')) {
      state = el.getAttribute('data-customer-state');
      known = true;
    }

    // Outside the US: ship date only.
    if (country && country !== 'US') {
      var rx = compute(el, null);
      main.innerHTML = '<span style="color:green">Ships ' + shipWords(rx) + '</span>';
      sub.hidden = true;
      zipWrap.hidden = true;
      return;
    }

    // ZIP outside the states we estimate (AK, HI, PR, military): ship date only.
    var supported = !known || !!state;
    var r = compute(el, supported ? state : null);

    if (r.arrive && supported) {
      // Greg 11/4: "Arrives <typical> to <9 in 10>" so long tails don't scare shoppers off; short so it fits one line on phones.
      main.innerHTML = sameDay(r.arriveEarly, r.arrive)
        ? '<span style="color:green">Arrives by <strong>' + fmtShort(r.arrive) + '</strong></span>'
        : '<span style="color:green">Arrives <strong>' + fmtShort(r.arriveEarly) + '</strong> to <strong>' + fmtShort(r.arrive) + '</strong></span>';
    } else {
      main.innerHTML = '<span style="color:green">Ships ' + shipWords(r) + '</span>';
    }

    // Amazon-style: the countdown only says how long the date holds; no ship-day wording.
    sub.textContent = r.minutesLeft !== null ? 'Order within ' + countdown(r.minutesLeft) + '.' : '';
    sub.hidden = !sub.textContent;

    if (zip) {
      toggle.textContent = 'Delivering to ' + zip + (state ? '' : ' (estimate not available)') + '. Change';
    } else if (state) {
      toggle.textContent = 'Delivering to ' + state + '. Change';
    } else {
      toggle.textContent = 'Enter ZIP for a more exact date';
    }
    zipWrap.hidden = false;
    if (form.hidden) form.querySelector('input').value = zip;
  }

  function init(el) {
    if (el.__deInit) return;
    el.__deInit = true;
    var toggle = el.querySelector('.delivery-estimate__zip-toggle');
    var form = el.querySelector('.delivery-estimate__zip-form');
    var input = form.querySelector('input');
    var save = form.querySelector('.delivery-estimate__zip-save');

    toggle.addEventListener('click', function () {
      form.hidden = !form.hidden;
      if (!form.hidden) input.focus();
    });
    function apply() {
      var v = (input.value || '').replace(/\D/g, '').slice(0, 5);
      if (v.length !== 5) { input.focus(); return; }
      storageSet(v);
      form.hidden = true;
      document.querySelectorAll('[data-delivery-estimate]').forEach(render);
    }
    save.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
    });

    render(el);
    // Keep the countdown current.
    setInterval(function () { render(el); }, 60000);
  }

  function boot() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor / section reloads.
  document.addEventListener('shopify:section:load', boot);
})();
